import React, {useEffect, useRef} from 'react';
import he from 'he';
import parse from 'html-react-parser';

const EventModal = ({ isOpen, onClose, event, locationLookup, categoryLookup }) => {
  const modalRef = useRef(null);

  const month = event.start.toLocaleString('default', { month: 'short' });
  const day   = event.start.toLocaleString('default', { weekday: 'long' });
  let time  = event.start.toLocaleString('default', {hour: "numeric", minute: "numeric"});
  if(time === "12:00 AM") 
    time = ' ';
  const end   = event.end.toLocaleString('default', {hour: "numeric", minute: "numeric"});
  // const phone = event.phone.replace(/[^0-9]/g, "");
  const phone = event.phone;
  const keyClose = (e) => {
    if(e.key === 'Escape') {
      onClose();
    }
  }

  const stopClose = (e) => {
    e.stopPropagation();
  }

  useEffect(() => {
    if(isOpen && modalRef.current) {
      modalRef.current.focus();
    }
  }, [isOpen])

  if (!isOpen || !event) return null;

  return (
    <div className="easycal-overlay" onKeyUp={keyClose} ref={modalRef} tabIndex={-1} onClick={onClose}>
      <div className="easycal-modal" onClick={stopClose}>
        <div className="modal-left">
          <img className="modal-img" src={event.image} />
        </div>
        <div className="modal-right">
          <p className="modal-close" onClick={onClose}>X</p>
          <div className='date-box'>
            <p className="date-text">{month}</p>
            <p className="date-num">{event.start.getDate()}</p>
            <p className="date-text date-day">{day}</p>
          </div>
          <div className='modal-info-wrapper'>
            <h5 className='modal-event-title'>{he.decode(event.title)} Discount Drug Mart</h5>
            <div className='modal-info'>
              {event.link  != '' && <a className="menu-icon modal-icon icon-cal" target={event.link.target} href={`${event.link.url}`}>{event.link.title}</a> } 
              {event.noend && <h6 className="menu-icon modal-icon icon-clock">{time}</h6>}
              {!event.noend && <h6 className="menu-icon modal-icon icon-clock">{time} - {end}</h6>}
            </div>
            <div className='modal-info'>
              <p>Schedule an Appointment</p>
              {phone && <a className="button" href={`tel:+1${phone.replace(/[^0-9]/g, "")}`}>Call {phone}</a>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventModal;